import common from "@/common/constants.js";
import { iDataset, iTask, iTest } from "@/services";

const state = {
  isCreate: true, // true: 생성, false: 수정
  isCloned: false,
  taskObject: {
    name: "",
    projectId: 0,
    projectName: "",
    interfaceName: "",
    interfaceId: 0,
    priceGroupId: 0,
    datasetId: 0,
    manualUrl: "",
    testConfig: {
      inspectTestConfig: {
        testDataset: {},
        candidateIds: [],
      },
      operateTestConfig: {
        testDataset: {},
        candidateIds: [],
      },
    },
    operatorList: [],
    inspectorList: [],

    workTimeConfig: {
      WORK_BEFORE_FILE_MAX: null,
      WORK_IN_PROGRESS_FILE_MAX: null,
      INSPECT_REJECT_FILE_MAX: null,
      WORK_COMPLETE_FILE_MAX: null,
      DELETE_REQUEST_FILE_MAX: null,
      INSPECT_IN_PROGRESS_FILE_MAX: null,
      UNOPERATE_SET_MAX: null,
      UNINSPECT_SET_MAX: null,
      OPERATE_FILE_MIN: null,
      INSPECT_FILE_MIN: null,
    },
    operateFileMinUnit: "초",
    inspectFileMinUnit: "초",
  },
  selectedDataset: {},
  isDatasetAvailable: true,
  datasetTree: [],

  // 세트 정보
  setInfo: {
    setId: 0,
    isSetComplete: false,
    isChanged: false,
  },
};

const mutations = {
  setIsCreate: (state) => {
    state.isCreate = true;
  },

  // 선택된 데이터셋 변경
  setSelectedDataset: (state, data) => {
    state.selectedDataset = data;
  },

  setProjectName: (state, data) => {
    state.taskObject.projectName = data;
  },

  setInterfaceId: (state, data) => {
    state.taskObject.interfaceId = data;
  },

  setInterfaceName: (state, data) => {
    state.taskObject.interfaceName = data;
  },

  setTaskName: (state, data) => {
    state.taskObject.name = data;
  },

  setManualLink: (state, data) => {
    state.taskObject.manualUrl = data;
  },

  setOperateTestDataset: (state, data) => {
    state.taskObject.testConfig.operateTestConfig.testDataset = data;
  },

  setInspectTestDataset: (state, data) => {
    state.taskObject.testConfig.inspectTestConfig.testDataset = data;
  },

  setOperateTestIds: (state, data) => {
    state.taskObject.testConfig.operateTestConfig.candidateIds = data;
  },

  setInspectTestIds: (state, data) => {
    state.taskObject.testConfig.inspectTestConfig.candidateIds = data;
  },

  setOperatorList: (state, data) => {
    state.taskObject.operatorList = data;
  },

  setInspectorList: (state, data) => {
    state.taskObject.inspectorList = data;
  },

  setProjectInfo: (state, data) => {
    state.taskObject.projectId = data.projectId;
  },

  setIsDatasetAvailable: (state, data) => {
    state.isDatasetAvailable = data;
  },

  setWorkTimeConfig: (state, data) => {
    state.taskObject.workTimeConfig[data.type] = data.time;
  },

  setOperateFileMinUnit: (state, data) => {
    state.taskObject.operateFileMinUnit = data;
  },

  setInspectFileMinUnit: (state, data) => {
    state.taskObject.inspectFileMinUnit = data;
  },

  setSetId: (state, data) => {
    state.setInfo.setId = data;
  },

  setIsSetComplete: (state, data) => {
    state.setInfo.isSetComplete = data;
  },

  setIsSetChanged: (state, data) => {
    state.setInfo.isChanged = data;
  },

  // 작업 취소 - 작업 데이터 초기화
  clearTaskData: (state) => {
    state.isCreate = true;
    state.isCloned = false;
    state.taskObject = {
      name: "",
      projectId: 0,
      projectName: "",
      interfaceName: "",
      interfaceId: 0,
      datasetId: 0,
      manualUrl: "",
      testConfig: {
        inspectTestConfig: {
          testDataset: {},
          candidateIds: [],
        },
        operateTestConfig: {
          testDataset: {},
          candidateIds: [],
        },
      },
      operatorList: [],
      inspectorList: [],

      workTimeConfig: {
        WORK_BEFORE_FILE_MAX: null,
        WORK_IN_PROGRESS_FILE_MAX: null,
        INSPECT_REJECT_FILE_MAX: null,
        WORK_COMPLETE_FILE_MAX: null,
        DELETE_REQUEST_FILE_MAX: null,
        INSPECT_IN_PROGRESS_FILE_MAX: null,
        UNOPERATE_SET_MAX: null,
        UNINSPECT_SET_MAX: null,
        OPERATE_FILE_MIN: null,
        INSPECT_FILE_MIN: null,
      },
      operateFileMinUnit: "초",
      inspectFileMinUnit: "초",
    };
    state.selectedDataset = {};
    state.isDatasetAvailable = true;
    state.datasetTree = [];

    state.setInfo = {
      setId: 0,
      isSetComplete: false,
      isChanged: false,
    };
  },

  clearSetInfo: (state) => {
    state.setInfo = {
      setId: 0,
      isSetComplete: false,
      isChanged: false,
    };
  },
};

const actions = {
  /** 데이터셋 트리 불러오기 */
  async setDatasetTree({ state }, projectId) {
    const res = await iDataset.getRootDatasets(projectId);
    if (!res.data.length) return;

    res.data.forEach(async (obj) => {
      if (obj.storageType === "S3") {
        const s3Id = obj.id;
        const s3Res = await iDataset.getDatasetsOfTree(s3Id);
        state.datasetTree[0] = s3Res.data;
      }
    });
  },

  /** 선택 데이터셋 값 저장 */
  async setSelectedDataset({ state, commit }, data) {
    state.taskObject.datasetId = data.datasetId;

    commit("setSelectedDataset", { ...data });
  },

  /** 생성: 작업 불러오기 (복사) */
  async getTaskClone({ state, dispatch }, { projectId, taskId }) {
    const res = await iTask.getTasksEdit({ id: taskId });
    const task = res.data.payload;

    state.isCloned = true;
    state.taskObject.name = task.name + "_복사";
    state.taskObject.projectId = projectId;
    state.taskObject.interfaceId = task.interfaceId;
    state.taskObject.manualUrl = task.manualUrl;

    await dispatch("setDatasetTree", projectId);

    // 같은 프로젝트면 데이터 불러오기
    if (projectId == task.projectId && task.datasetId) {
      state.taskObject.datasetId = task.datasetId;
      await dispatch("setTasksDataset", task.datasetId);
    }
    await dispatch("setTasksTimes", task.id);
    return task;
  },

  /** 수정: 수정할 작업 정보 불러오기 */
  async setTasks({ state, commit, dispatch }, taskId) {
    commit("clearTaskData");
    state.isCreate = false;

    const res = await iTask.getTasksEdit({ id: taskId });
    const task = res.data.payload;

    state.taskObject.id = task.id;
    state.taskObject.name = task.name;
    state.taskObject.projectId = task.projectId;
    state.taskObject.interfaceId = task.interfaceId;
    state.taskObject.datasetId = task.datasetId;
    state.taskObject.priceGroupId = task.priceGroupId;
    state.taskObject.manualUrl = task.manualUrl;
    state.setInfo.isSetComplete = task.hasSet;

    // 데이터셋 불러오기
    if (task.datasetId) {
      await dispatch("setTasksDataset", task.datasetId);
    }
    // 테스트 불러오기
    await dispatch("setTasksTesters", task.id);

    // 담당자 목록 불러오기
    await dispatch("setTasksMembers", taskId);
    // 파일 할당 유지 시간, 최소 작업/검수 시간 불러오기
    await dispatch("setTasksTimes", taskId);
  },

  /** 수정: 데이터셋 불러오기 */
  async setTasksDataset({ commit }, datasetId) {
    const res = await iDataset.getDatasetsOfTree(datasetId);

    commit("setSelectedDataset", {
      datasetId: datasetId,
      datasetName: res.data.datasetName,
      datasetPath: res.data.datasetPath,
      datasetCount:
        res.data.summary[Object.keys(res.data.summary)[0]].datasetCount,
    });
  },

  /** 수정: 테스트 목록 불러오기 */
  async setTasksTesters({ state, dispatch }, taskId) {
    const res = await iTest.getTestCandidates({
      taskId,
      testStatuses: ["T", "E", "P"],
    });
    if (res.data?.code) {
      console.error(`[ERROR]: ${res.data?.code}`);
      return;
    }
    const datas = res.data?.payload;

    // get test dataset Id
    datas.operateDatasetId = await dispatch("getTestDatasetId", {
      type: "O",
      taskId,
    });
    datas.inspectDatasetId = await dispatch("getTestDatasetId", {
      type: "I",
      taskId,
    });

    // set test dataset
    if (datas.operateDatasetId) {
      state.taskObject.testConfig.operateTestConfig.testDataset =
        await dispatch("getDatasetSummary", datas.operateDatasetId);
    }
    state.taskObject.testConfig.operateTestConfig.candidateIds =
      datas.operators;
    if (datas.inspectDatasetId) {
      state.taskObject.testConfig.inspectTestConfig.testDataset =
        await dispatch("getDatasetSummary", datas.inspectDatasetId);
    }

    state.taskObject.testConfig.inspectTestConfig.candidateIds =
      datas.inspectors;
  },

  /** 테스트 데이터셋 ID 조회 */
  async getTestDatasetId({ state }, { type, taskId }) {
    state;
    const res = await iTest.getTestList({
      candidateTypes: type,
      limit: 1,
      order: common.COMMON_LIST_ORDER,
      taskId: taskId,
    });
    if (res.data?.payload.testListItems.length > 0) {
      return res.data?.payload.testListItems[0].testDatasetId;
    }
  },

  /** 데이터셋id로 선택된 데이터셋 조회 */
  async getDatasetSummary({ state }, datasetId) {
    let data = {};
    state.datasetTree.forEach((tree) => {
      if (tree.summary) {
        for (const id in tree.summary) {
          if (datasetId == id) {
            const summary = tree.summary[id];

            let path = "";
            if (summary.path.split("/").length === 1) {
              path = tree.datasetName;
            } else {
              path =
                summary.path.split("/")[summary.path.split("/").length - 1];
            }

            data = {
              datasetId: datasetId,
              datasetName: path,
              datasetCount: summary.datasetCount,
            };
            return;
          }
        }
      }
    });
    return data;
  },

  /** 수정: 담당자 목록 불러오기 */
  async setTasksMembers({ state }, taskId) {
    const res = await iTask.getTasksMembers({ id: taskId });
    if (res.data?.code) {
      console.error(`[ERROR]: ${res.data?.code}`);
      return;
    }

    const members = res.data?.payload;
    state.taskObject.operatorList = members.operators;
    state.taskObject.inspectorList = members.inspectors;
  },

  /** 수정: 파일 할당 유지 시간, 최소 작업/검수 시간 불러오기 */
  async setTasksTimes({ state, commit }, taskId) {
    const res = await iTask.getTasksTimes({ id: taskId });
    if (res.data?.code) {
      console.error(`[ERROR]: ${res.data?.code}`);
      return;
    }

    res.data?.payload.forEach((item) => {
      if (
        item.type === "OPERATE_FILE_MIN" ||
        item.type === "INSPECT_FILE_MIN"
      ) {
        let t;
        if (item.time > 60 && item.type === "OPERATE_FILE_MIN") {
          if (item.time % 60 === 0) {
            state.taskObject.operateFileMinUnit = "분";
            t = item.time / 60;
          } else {
            t = item.time;
          }
        } else if (item.time > 60 && item.type === "INSPECT_FILE_MIN") {
          if (item.time % 60 === 0) {
            state.taskObject.inspectFileMinUnit = "분";
            t = item.time / 60;
          } else {
            t = item.time;
          }
        } else {
          t = item.time;
        }

        commit("setWorkTimeConfig", {
          time: t, // 초 -> 초 or 분
          type: item.type,
        });
      } else {
        commit("setWorkTimeConfig", {
          time: item.time / 3600, // 초 -> 시간
          type: item.type,
        });
      }
    });
  },

  /** 세트 테이블 삭제 */
  async deleteCandidates({ commit }, payload) {
    const res = await iTask.deleteCandidates(payload);
    if (res.data?.code) {
      console.error(`[ERROR]: ${res.data?.code}`);
      return;
    }
    commit("clearSetInfo");
  },

  /** 작업 생성 API 요청 */
  async requestCreateTaskAPI({ state, dispatch }, payload) {
    const createPayload = {
      ...payload,
      workTimeConfig: await dispatch(
        "setWorkTimeConfig",
        state.taskObject.workTimeConfig
      ),
      interfaceId: state.taskObject.interfaceId,
      projectId: state.taskObject.projectId,
    };
    const res = await iTask.createTask(createPayload);
    return res;
  },

  /** 작업 수정 API 요청 */
  async requestUpdateTaskAPI({ state }, payload) {
    const updatePayload = {
      ...payload,
      taskId: state.taskObject.id,
    };
    const res = await iTask.updateTask(updatePayload);
    return res;
  },

  /** 작업 생성/수정 API 요청 */
  async requestTaskAPI({ state, dispatch }) {
    let payload = {
      datasetId: state.taskObject.datasetId || undefined,
      manualUrl: state.taskObject.manualUrl,
      name: state.taskObject.name,
      setId: state.setInfo.setId || undefined,
      testConfig: {
        operateTestConfig: {
          testDatasetId:
            state.taskObject.testConfig.operateTestConfig.testDataset.datasetId,
          candidateIds:
            state.taskObject.testConfig.operateTestConfig.candidateIds.map(
              (item) => item.userId
            ),
        },
        inspectTestConfig: {
          testDatasetId:
            state.taskObject.testConfig.inspectTestConfig.testDataset.datasetId,
          candidateIds:
            state.taskObject.testConfig.inspectTestConfig.candidateIds.map(
              (item) => item.userId
            ),
        },
      },
      workerConfig: {
        inspectorIds: state.taskObject.inspectorList.map((item) => item.userId),
        operatorIds: state.taskObject.operatorList.map((item) => item.userId),
      },
    };

    let res;
    if (state.isCreate) {
      res = await dispatch("requestCreateTaskAPI", payload);
    } else {
      res = await dispatch("requestUpdateTaskAPI", payload);
    }
    return res;
  },

  /** 파일 할당 유지 시간, 최소 작업/검수 시간 설정 */
  async setWorkTimeConfig({ state }, config) {
    let newConfig = [];
    Object.keys(config).forEach((item) => {
      let value = config[item];
      if (
        value &&
        (item === "OPERATE_FILE_MIN" || item === "INSPECT_FILE_MIN")
      ) {
        // 최소 작업/검수 시간
        if (
          (item === "OPERATE_FILE_MIN" &&
            state.taskObject.operateFileMinUnit === "분") ||
          (item === "INSPECT_FILE_MIN" &&
            state.taskObject.inspectFileMinUnit === "분")
        ) {
          value = value * 60;
        }
        newConfig.push({
          time: value,
          type: item,
        });
      } else if (value) {
        // 파일 할당 유지 시간
        newConfig.push({
          time: parseInt(value) * 3600, // hour -> second
          type: item,
        });
      }
    });
    return newConfig;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
